
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banco-do-auto",
      function () {
        return require("private-next-pages/banco-do-auto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banco-do-auto"])
      });
    }
  